import { Helmet } from "react-helmet-async";
import type { GameLocale } from "../i18n/types";
import { DA_FAQ, DA_GAME, DA_HOWTO, DA_ORG, DA_WEBSITE } from "../seo/daSchema";
import { NO_FAQ, NO_WEBPAGE } from "../seo/noSchema";

const SITE = "https://wørdle.nu";
const OG_IMAGE = `${SITE}/w%C3%B8rdle-nu.webp`;

export function SeoHead({ locale }: { locale: GameLocale }) {
  if (locale === "no") {
    return (
      <Helmet prioritizeSeoTags htmlAttributes={{ lang: "no" }}>
        <title>Wordle – spill norsk Wordle gratis</title>
        <meta
          name="description"
          content="Spill Wordle på norsk. Gjett dagens ord på 6 forsøk. Nytt 5-bokstavers ord hver dag. Gratis, uten innlogging, rett i nettleseren."
        />
        <meta
          name="keywords"
          content="wordle, norsk wordle, ordspill, gjett ordet, norske ord, wørdle.nu"
        />
        <meta name="author" content="Wørdle.nu" />
        <meta name="language" content="no" />
        <link rel="canonical" href={`${SITE}/no`} />
        <link rel="alternate" hrefLang="da" href={`${SITE}/`} />
        <link rel="alternate" hrefLang="no" href={`${SITE}/no`} />
        <link rel="alternate" hrefLang="x-default" href={`${SITE}/`} />
        <meta property="og:title" content="Wordle – spill norsk Wordle gratis" />
        <meta
          property="og:description"
          content="Spill Wordle på norsk. Gjett dagens ord på 6 forsøk. Nytt 5-bokstavers ord hver dag. Gratis, uten innlogging."
        />
        <meta property="og:locale" content="no_NO" />
        <meta property="og:url" content={`${SITE}/no`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Wørdle.nu" />
        <meta property="og:image" content={OG_IMAGE} />
        <meta property="og:image:alt" content="Wordle – gjett dagens norske ord" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Wordle – spill norsk Wordle gratis" />
        <meta
          name="twitter:description"
          content="Spill Wordle på norsk. Gjett dagens ord på 6 forsøk. Gratis, uten innlogging."
        />
        <meta name="twitter:image" content={OG_IMAGE} />
        <script type="application/ld+json">
          {JSON.stringify(NO_WEBPAGE)}
        </script>
        <script type="application/ld+json">{JSON.stringify(NO_FAQ)}</script>
      </Helmet>
    );
  }

  return (
    <Helmet prioritizeSeoTags htmlAttributes={{ lang: "da" }}>
      <title>Wørdle - Spil Dansk Wordle Gratis</title>
      <meta
        name="description"
        content="Spil Wørdle - det danske Wordle. Gæt dagens ord på 6 forsøg. Nyt 5-bogstavs ord hver dag. Gratis, ingen login, direkte i browseren."
      />
      <meta
        name="keywords"
        content="wørdle, dansk wordle, ordspil, gæt ordet, danske ord, wørdle.nu"
      />
      <meta name="author" content="Wørdle.nu" />
      <meta name="language" content="da" />
      <link rel="canonical" href={`${SITE}/`} />
      <link rel="alternate" hrefLang="da" href={`${SITE}/`} />
      <link rel="alternate" hrefLang="no" href={`${SITE}/no`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE}/`} />
      <meta property="og:title" content="Wørdle - Spil Dansk Wordle Gratis" />
      <meta
        property="og:description"
        content="Spil Wørdle - det danske Wordle. Gæt dagens ord på 6 forsøg. Nyt 5-bogstavs ord hver dag. Gratis, ingen login, direkte i browseren."
      />
      <meta property="og:locale" content="da_DK" />
      <meta property="og:url" content={SITE} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Wørdle.nu" />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:alt" content="Wørdle.nu - Gæt dagens danske ord" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Wørdle - Spil Dansk Wordle Gratis" />
      <meta
        name="twitter:description"
        content="Spil Wørdle - det danske Wordle. Gæt dagens ord på 6 forsøg. Gratis, ingen login, direkte i browseren."
      />
      <meta name="twitter:image" content={OG_IMAGE} />
      <script type="application/ld+json">{JSON.stringify(DA_GAME)}</script>
      <script type="application/ld+json">{JSON.stringify(DA_WEBSITE)}</script>
      <script type="application/ld+json">{JSON.stringify(DA_ORG)}</script>
      <script type="application/ld+json">{JSON.stringify(DA_FAQ)}</script>
      <script type="application/ld+json">{JSON.stringify(DA_HOWTO)}</script>
    </Helmet>
  );
}
